<template>
  <div class="manage">
    <!-- 顶部导航栏 -->
    <header class="topBar">
      <div class="topBar_left">
        <div class="topBar_logo">
          <svg viewBox="0 0 32 32" fill="none">
            <rect width="32" height="32" rx="8" fill="#4f46e5"/>
            <circle cx="16" cy="16" r="7" fill="rgba(255,255,255,0.25)" stroke="#fff" stroke-width="1.5"/>
            <rect x="14.5" y="10" width="3" height="12" rx="1.5" fill="#fff"/>
            <rect x="10" y="14.5" width="12" height="3" rx="1.5" fill="#fff"/>
          </svg>
        </div>
        <span class="topBar_title">利杰鑫后台管理</span>
      </div>
      <div class="topBar_right">
        <div class="topBar_user">
          <div class="avatar">{{ adminType_info.value.adminname?.charAt(0) }}</div>
          <span class="username">{{ adminType_info.value.adminname }}</span>
        </div>
        <div class="topBar_exit" @click="exitLogin">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
            <polyline points="16 17 21 12 16 7"/>
            <line x1="21" y1="12" x2="9" y2="12"/>
          </svg>
          <span>退出登录</span>
        </div>
      </div>
    </header>

    <div class="manage_content">
      <!-- 左侧菜单 -->
      <aside class="manage_aside">
        <nav class="aside_nav">
          <div
            v-for="(item,i) in select_asideLisr"
            :key="i"
            class="aside_item"
            :class="{'aside_item--active': selectIndex==i}"
            @click="routerClick(item.asideUrl,i)"
          >
            <div class="aside_icon" v-html="getIcon(item.asideName)"></div>
            <span>{{ item.asideName }}</span>
          </div>
        </nav>
        <div class="aside_footer">
          <div class="aside_version">v1.0.0</div>
        </div>
      </aside>

      <!-- 主内容区 -->
      <main class="manage_show">
        <router-view />
      </main>
    </div>
  </div>
</template>
<script setup>
import { computed, getCurrentInstance, onMounted, ref,onBeforeMount } from 'vue';
import { Button, Field, showToast   } from 'vant'
import {useRouter } from 'vue-router';
import { store } from '@/store/index';

import { getSecondAdmin } from '@/api/index'
// const store = useStore();
import 'vant/lib/index.css';
const router = useRouter();
const selectIndex = ref(0)
const select_asideLisr = ref([
  {'asideName':'增加管理员','asideUrl':'/AdminManage'},
  {'asideName':'用户管理','asideUrl':'/UserManage'},
  {'asideName':'一针断痔','asideUrl':'/AddressManage'},
  {'asideName':'静脉曲张','asideUrl':'/JmqzAddressManage'},
  {'asideName':'视频管理','asideUrl':'/videoManage'}
])
const secondAdmin_info = ([])
const adminType_info = ({})

// 菜单图标 SVG（内联 SVG 字符串，v-html 渲染）
const iconMap = {
  '增加管理员': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/><line x1="16" y1="11" x2="16" y2="17"/><line x1="13" y1="14" x2="19" y2="14"/></svg>',
  '用户管理': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>',
  '一针断痔': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2v20"/><path d="M12 2C12 2 4 10 4 14a4 4 0 0 0 8 0c0-4-4-7.8-4-7.8"/><path d="M12 2c0 0 8 8 8 12a4 4 0 0 1-8 0c0-4 4-7.8 4-7.8"/></svg>',
  '静脉曲张': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12h16"/><path d="M4 12c0 0 2-3 4-3s2 3 4 3 2-3 4-3 2 3 4 3"/><circle cx="12" cy="12" r="10"/></svg>',
  '视频管理': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="5 3 19 12 5 21 5 3"/><rect x="3" y="3" width="18" height="18" rx="2" ry="2"/></svg>',
}
const getIcon = (name) => iconMap[name] || ''

onBeforeMount(()=>{
  let logInfo = JSON.parse(localStorage.getItem('logInfo'))
  adminType_info.value = logInfo
  if(adminType_info.value.admintype==1){
    let secondInfo = JSON.parse(localStorage.getItem('secondRes'))
    secondAdmin_info.value = secondInfo
    store.commit('setAdminType',secondAdmin_info.value)
  }
  store.commit('setAdminType',logInfo)
})
onMounted(()=>{
  let urlindex = localStorage.getItem('urlindex')
  selectIndex.value = Number(urlindex)
  if(adminType_info.value.admintype==2){
    select_asideLisr.value = [
      {'asideName':'用户管理','asideUrl':'/UserManage'},
      {'asideName':'一针断痔','asideUrl':'/AddressManage'},
      {'asideName':'静脉曲张','asideUrl':'/JmqzAddressManage'},
      {'asideName':'视频管理','asideUrl':'/videoManage'}
    ]
  }
})
const routerClick = (url,i)=>{
  selectIndex.value = i
  router.push(url);
  localStorage.setItem('urlindex',i)
}
const exitLogin = ()=>{
  localStorage.setItem('isLogin',false)
  router.push('/');
}
</script>
<style scoped>
/* ===== 滚动条 ===== */
.manage ::-webkit-scrollbar { width: 5px; }
.manage ::-webkit-scrollbar-track { background: transparent; }
.manage ::-webkit-scrollbar-thumb { background: rgba(99,102,241,0.35); border-radius: 3px; }
.manage ::-webkit-scrollbar-thumb:hover { background: rgba(99,102,241,0.6); }

.manage {
  width: 100%; height: 100%;
  display: flex; flex-direction: column;
  background: #f0f2f5;
  user-select: none;
}

/* ===== 顶部栏 ===== */
.topBar {
  height: 56px; min-height: 56px;
  background: #fff;
  display: flex; align-items: center; justify-content: space-between;
  padding: 0 24px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.06);
  z-index: 100;
}
.topBar_left {
  display: flex; align-items: center; gap: 10px;
}
.topBar_logo {
  width: 32px; height: 32px; flex-shrink: 0;
}
.topBar_logo svg { width: 100%; height: 100%; }
.topBar_title {
  font-size: 16px; font-weight: 700; color: #1a1a1a;
  letter-spacing: 1px;
}
.topBar_right {
  display: flex; align-items: center; gap: 24px;
}
.topBar_user {
  display: flex; align-items: center; gap: 8px;
}
.avatar {
  width: 30px; height: 30px; border-radius: 50%;
  background: linear-gradient(135deg, #6366f1, #818cf8);
  color: #fff; font-size: 13px; font-weight: 600;
  display: flex; align-items: center; justify-content: center;
}
.username {
  font-size: 13px; color: #555;
}
.topBar_exit {
  display: flex; align-items: center; gap: 4px;
  font-size: 13px; color: #888;
  cursor: pointer; transition: color 0.2s, background 0.2s;
  padding: 6px 12px; border-radius: 8px;
}
.topBar_exit:hover { color: #ef4444; background: #fef2f2; }
.topBar_exit svg { width: 16px; height: 16px; }

/* ===== 主体区域 ===== */
.manage_content {
  flex: 1; display: flex; overflow: hidden;
}

/* ===== 左侧菜单 ===== */
.manage_aside {
  width: 210px; min-width: 210px;
  background: linear-gradient(180deg, #1e1b4b 0%, #312e81 50%, #3730a3 100%);
  display: flex; flex-direction: column;
  color: rgba(255,255,255,0.85);
  position: relative; overflow: hidden;
}
.manage_aside::before {
  content: '';
  position: absolute; inset: 0;
  background:
    radial-gradient(ellipse 80% 50% at 50% 0%, rgba(129,140,248,0.18) 0%, transparent 60%),
    radial-gradient(ellipse 60% 40% at 50% 100%, rgba(99,102,241,0.12) 0%, transparent 60%);
  pointer-events: none;
}

.aside_nav {
  flex: 1; padding: 16px 0; overflow-y: auto;
  position: relative; z-index: 1;
}
.aside_nav::-webkit-scrollbar { width: 0; }

.aside_item {
  display: flex; align-items: center; gap: 12px;
  height: 48px;
  margin: 2px 12px;
  padding: 0 16px;
  border-radius: 10px;
  font-size: 14px; font-weight: 400;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
  color: rgba(255,255,255,0.7);
}
.aside_item:hover {
  background: rgba(255,255,255,0.1);
  color: #fff;
}
.aside_item--active {
  background: rgba(129,140,248,0.25) !important;
  color: #fff !important;
  font-weight: 600;
  box-shadow: inset 3px 0 0 #818cf8;
}
.aside_icon {
  width: 20px; height: 20px; flex-shrink: 0;
  display: flex; align-items: center; justify-content: center;
}
.aside_icon :deep(svg) {
  width: 18px; height: 18px;
}
.aside_item--active .aside_icon :deep(svg) {
  color: #a5b4fc;
}

.aside_footer {
  padding: 14px 20px;
  border-top: 1px solid rgba(255,255,255,0.08);
  position: relative; z-index: 1;
}
.aside_version {
  font-size: 11px; color: rgba(255,255,255,0.3);
  letter-spacing: 1px;
}

/* ===== 主内容区 ===== */
.manage_show {
  flex: 1;
  background: #f0f2f5;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}
.manage_show > :deep(.userManage),
.manage_show > :deep(.addressManage),
.manage_show > :deep(.videoManage),
.manage_show > :deep(.adminManage),
.manage_show > :deep(.jmzManage) {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
</style>
